import { ro } from "date-fns/locale";
import { ROLE_GROUPS } from "../auth/roles";

//Parent nav items for project details page.
export const projectDetailsV2Tabs = [
  { key: "splosno", label: "Splošno", to: "splosno", roles: ROLE_GROUPS.ALL },
  {
    key: "partnerstvo",
    label: "Partnerstvo",
    to: "partnerstvo",
    roles: ROLE_GROUPS.ALL,
  },
  {
    key: "finance",
    label: "Finance",
    to: "finance",
    roles: ROLE_GROUPS.GLOBALNI_AND_FAKULTETNI,
  },
];

export const partnerstvoTabs = [
  {
    key: "partnerske-organizacije",
    label: "Partnerske organizacije",
    to: "partnerske-organizacije",
  },
  {
    key: "sodelovanje-znotraj-um",
    label: "Sodelovanje znotraj UM",
    to: "sodelovanje-znotraj-um",
  },
];

export const financeTabs = [
  {
    key: "nacrtovana-vrednost-projekta",
    label: "Načrtovana vrednost projekta",
    to: "nacrtovana-vrednost-projekta",
    roles: ROLE_GROUPS.GLOBALNI_AND_FAKULTETNI, // only editors see this tab
  },
  {
    key: "realizirana-vrednost-projekta",
    label: "Realizirana vrednost projekta",
    to: "realizirana-vrednost-projekta",
    roles: ROLE_GROUPS.GLOBALNI_AND_FAKULTETNI, // only editors see this tab
  },
  {
    key: "stroskovna-mesta",
    label: "Stroškovna mesta",
    to: "stroskovna-mesta",
    roles: ROLE_GROUPS.GLOBALNI_AND_FAKULTETNI, // only editors see this tab
  },
  {
    key: "deminimis",
    label: "De minimis",
    to: "deminimis",
    roles: ROLE_GROUPS.GLOBALNI_AND_FAKULTETNI, // only editors see this tab
  },
];
